import React from 'react';
import CreditCardRoundedIcon from '@material-ui/icons/CreditCardRounded';
import OpenInNewRoundedIcon from '@material-ui/icons/OpenInNewRounded';
import ReceiptRoundedIcon from '@material-ui/icons/ReceiptRounded';

import { ListCard, ListCardItem, FullScreenCard } from 'components';
import { formatTimestamp, DISPLAY_DATE_SHORT_FORMAT } from 'utils/dates';
import useSubscription from 'hooks/useSubscription';
import StripeBillingRedirect from './StripeBillingRedirect';

const PaymentDetails: React.SFC = () => {
  const { loading, subscription, paymentMethod } = useSubscription();
  const [isRedirecting, setRedirecting] = React.useState(false);

  if (loading || !subscription || !paymentMethod) return <></>;

  const { latestInvoice } = subscription!;
  const { periodStart } = latestInvoice;
  const { card } = paymentMethod!;
  const { last4, brand } = card;
  const lastPaymentDate = formatTimestamp(DISPLAY_DATE_SHORT_FORMAT)(periodStart);

  const subscriptionListItems: ListCardItem[] = [
    {
      leftIcon: <CreditCardRoundedIcon />,
      secondaryText: 'Payment Method',
      primaryText: `${brand?.toUpperCase()} ending in ${last4}`,
      actionIcon: <OpenInNewRoundedIcon />,
      onActionClick: () => setRedirecting(true),
    },
    {
      leftIcon: <ReceiptRoundedIcon />,
      secondaryText: 'Billing History',
      primaryText: `Last payment on ${lastPaymentDate}`,
      actionIcon: <OpenInNewRoundedIcon />,
      onActionClick: () => setRedirecting(true),
    },
  ];

  return (
    <>
      <ListCard title="Payment Details" reverseLabels listItems={subscriptionListItems} />
      {isRedirecting && (
        <FullScreenCard hideLogo showOverlay>
          <StripeBillingRedirect />
        </FullScreenCard>
      )}
    </>
  );
};

export default PaymentDetails;
